import React from 'react';
import { motion } from 'framer-motion';
import { Container } from '../ui/Section';
import { Button } from '../ui/Button';
import { PILLARS } from '../../data/site';
import { IMAGES } from '../../data/solutions';
export function Hero() {
  return <section className="relative isolate overflow-hidden bg-graphite-900" data-id="element-310" data-mp="jnf509ohur1w">
      <img src={IMAGES.hero} alt="Centro de distribución con camiones en muelle y autopista con transporte de cargas al atardecer" className="absolute inset-0 h-full w-full object-cover" loading="eager" data-id="element-311" data-mp="epdkrlfc0lou" />
      <div className="absolute inset-0 bg-graphite-900/72" aria-hidden="true" data-id="element-312" data-mp="5rtge3m6a9a0" />
      <div className="absolute inset-x-0 bottom-0 h-2/3 bg-graphite-900/55" aria-hidden="true" data-id="element-313" data-mp="qm9e6rute4e" />

      <Container className="relative flex min-h-[calc(100vh-72px)] flex-col justify-end pb-0 pt-24 md:pt-32" data-id="element-314" data-mp="3ryhxl7gumvjk">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-w-4xl pb-14 md:pb-20" data-id="element-315" data-mp="1v2apwddqhoqw">
          <p className="font-display text-xs font-semibold uppercase tracking-[0.22em] text-accent-400" data-id="element-316" data-mp="1rv5sqdrpvs56">
            Infraestructura operativa para empresas
          </p>
          <h1 className="mt-6 font-display text-[2.7rem] font-bold leading-[0.98] tracking-tightest text-white sm:text-6xl lg:text-[4.6rem]" data-id="element-317" data-mp="1d097mzyt7aao">
            Operaciones que funcionan.
            <br data-id="element-318" data-mp="25nlxpk46i08q" />
            <span className="text-brand-200" data-id="element-319" data-mp="25p6gkch4ruqr">Infraestructura que escala.</span>
          </h1>
          <p className="mt-7 max-w-2xl text-lg leading-relaxed text-mist-200 md:text-xl" data-id="element-320" data-mp="2anzu24wf3lqx">
            Integramos logística, Facility Management, tecnología, seguridad y gestión operativa para que las empresas
            puedan concentrarse en hacer crecer su negocio.
          </p>
          <div className="mt-10 flex flex-wrap gap-3" data-id="element-321" data-mp="2ok4wpgl9q7rk">
            <Button to="/contacto?servicio=Diagn%C3%B3stico%20operativo" size="lg" withArrow trackingLocation="home-hero" className="bg-accent-500 text-graphite-900 hover:bg-accent-400" data-id="element-322" data-mp="2tcy5qgnrs29g">
              Solicitar diagnóstico operativo
            </Button>
            <Button to="/soluciones" variant="onDark" size="lg" trackingLocation="home-hero" data-id="element-323" data-mp="2u65heliaygk0">
              Explorar soluciones
            </Button>
          </div>
        </motion.div>

        <ul className="flex flex-wrap items-center gap-x-6 gap-y-3 border-t border-white/15 py-6 text-xs font-semibold uppercase tracking-[0.14em] text-mist-200 md:gap-x-10 md:text-[13px]" data-id="element-324" data-mp="2kakjozk9o2g2">
          {PILLARS.map(pillar => <li key={pillar} className="flex items-center gap-3" data-id="element-325" data-mp="2ahn00q3jg7fv">
              <span className="h-1 w-1 bg-accent-400" aria-hidden="true" data-id="element-326" data-mp="26j5ugazrn50k" />
              {pillar}
            </li>)}
        </ul>
      </Container>
    </section>;
}